<script setup lang="ts">
</script>

<template>
	<UContainer class="grid min-h-screen grid-rows-[1fr_auto] px-4 sm:px-6 lg:px-14 py-8">
		<WidgetLanguageSwitcher class="absolute top-4 right-4 z-50" />
		<slot />
		<TheFooter />
	</UContainer>
</template>
